import type { PetitionDraft } from '#src/app/shared/api/petitionDraft';

import { classifyEntry } from './classifyEntry';
import { resolveDraftLanding } from './resolveDraftLanding';
import type { DraftState } from './resolveDraftLanding';
import type { SapLandingStep } from './types';

/**
 * Where to go, composing the two axes. `resolved` and `deeplink` bypass the draft entirely; only a
 * `default` entry consults it.
 */
export type EntryDecision =
	| { kind: 'resolved' }
	| { kind: 'deeplink' }
	| { kind: 'from_draft'; step: SapLandingStep; draftState: DraftState; parseException: unknown };

export function resolveEntry(
	startedFlowParam: string | undefined,
	draft: PetitionDraft,
	{ isNewDraft }: { isNewDraft: boolean },
): EntryDecision {
	const entry = classifyEntry(startedFlowParam);

	if (entry === 'resolved') return { kind: 'resolved' };
	if (entry === 'deeplink') return { kind: 'deeplink' };

	const { landingStep, draftState, parseException } = resolveDraftLanding(draft, { isNewDraft });
	return { kind: 'from_draft', step: landingStep, draftState, parseException: parseException ?? null };
}
